import { memo as Memo, useMemo, useState, useRef, useEffect } from 'react';
import { gsap } from 'gsap';

//* HOC's
import withLanguageContext from '@/context/consumerHOC/LanguageConsumer';

//* Helpers
import breakString from '@helpers/breakString';

//* Components
import Text from '@/components/global/Text';
import Button from '@components/global/Button';
import MinTitle from '@components/global/MinTitle';
import CustomCollapse from '@components/global/CustomCollapse';
import ArrowLeftBtn from '@components/global/SvgComponents/ArrowLeftBtn';

//* Styles
import OpenRolesStyle from './style';

const OpenRoles = Memo(({ teamFormRoles, active, translate, ...props }) => {
	//! States
	const [selectedIndex, setSelectedIndex] = useState('');

	const handleClick = (index) => {
		if (selectedIndex === index) {
			setSelectedIndex('');
		} else {
			setSelectedIndex(index);
		}
	};

	//! Refs
	const topRef = useRef();

	//! Animation
	const tl = useMemo(() => gsap.timeline({ delay: 0.8 }), []);

	useEffect(() => {
		const arr = [topRef.current.childNodes];
		if (active) {
			tl.staggerTo(
				[arr],
				0,
				{
					opacity: 1,
				},
				0.2
			);
		} else {
			tl.staggerTo(
				[arr],
				0,
				{
					opacity: 0,
				},
				0
			);
		}
	}, [active]);

	return (
		<OpenRolesStyle>
			<MinTitle
				active={active}
				title={breakString(teamFormRoles.title)}
			/>

			<div
				ref={topRef}
				className={'RolesItemCont'}>
				{teamFormRoles.roles.map((item, ind) => {
					return (
						<div
							key={ind}
							className={'RolesItemWrap'}>
							<div
								className={'RolesItem'}
								onClick={() => {
									handleClick(ind);
								}}>
								<Text
									tag={'h4'}
									className={`h6 font-poppins font-medium Profession`}>
									{item.profession}
								</Text>

								<div className={'PlusCont'}>
									<i className={'Plus'}>
										<svg
											className='svg-max'
											preserveAspectRatio='none'
											viewBox='0 0 56 56'>
											<line
												x2='56'
												transform='translate(0 28.337)'
											/>
											<line
												x2='56'
												transform='translate(28.337) rotate(90)'
												opacity={ind === selectedIndex ? 0 : 1}
											/>
										</svg>
									</i>
								</div>

								<Text className={`font-poppins font-light p-m WorkingHours`}>{item.working_hours}</Text>

								<Text className={`font-poppins font-light p-m Location`}>{item.location}</Text>
							</div>

							<CustomCollapse isCollapsed={ind === selectedIndex}>
								<div className={'RolesItemPopUpCont'}>
									{item.description.map((otherInfoItem, otherInfoIndex) => {
										return (
											<div
												key={otherInfoIndex}
												className={'RolesItemPopUp'}>
												<Text className={`p-m font-anonymous font-regular RolesPopUpTile`}>{otherInfoItem.title}</Text>

												<ul className={'RolesItemPopUpListCont'}>
													{otherInfoItem.children.map((otherInfoList, otherInfoListIndex) => {
														return (
															<li
																key={otherInfoListIndex}
																className={`p-m font-poppins font-regular RolesPopUpList`}>
																{otherInfoList.description}
															</li>
														);
													})}
												</ul>
											</div>
										);
									})}

									<div className={'ApplyInfoLink'}>
										<div className={'BtnArrow'}>
											<ArrowLeftBtn animate={ind === selectedIndex} />
										</div>

										<Button
											scrollLink
											onClick={props.onClick}
											className={'scrollLink'}
											text={translate('Apply')}
										/>
									</div>
								</div>
							</CustomCollapse>
						</div>
					);
				})}
			</div>
		</OpenRolesStyle>
	);
});

export default withLanguageContext(OpenRoles, ['translate']);
